<template>
  <div>
    <el-dialog
      id="create-modal"
      class="form-modal"
      v-loading="createProcessing"
      :visible.sync="createVisible"
      :fullscreen="true"
      :show-close="false"
      :modal="false"
      @closed="resetFields"
    >
      <div id="create-modal-header" class="modal-header">
        <div class="modal-header-layout flex grid-6 align-center">
          <h1 class="modal-title col-2">Create Toll Free</h1>
          <div class="modal-actions col-2">
            <el-button type="primary" @click="orderTollFree">Create</el-button>
            <el-button
              type="default"
              class="hidden-xs-only"
              @click="cancelOperation"
            >
              Cancel
            </el-button>
            <el-button
              type="default"
              icon="el-icon-close"
              class="hidden-sm-and-up"
              @click="cancelOperation"
            ></el-button>
          </div>
        </div>
      </div>

      <el-form>
        <div class="inline-form-group">
          <el-radio-group v-model="searchType" class="mb-10">
            <el-radio label="inventory">
              <span class="black-text">Search inventory</span>
            </el-radio>
            <el-radio label="exact">
              <span class="black-text"> Search exact number</span>
            </el-radio>
          </el-radio-group>
        </div>
        <div class="inline-form-group">
          <el-col :span="11">
            <dads-select
              v-if="searchType === 'inventory'"
              v-model="createForm.numberFormat"
              :value="createForm.numberFormat"
              placeholder="Number Format"
              @change="getTfInventory"
              filterable
            >
              <template slot="prefix">Number Format</template>
              <el-option
                v-for="{ label, value } in numberFormatOptions"
                :key="value"
                :label="label"
                :value="value"
              />
            </dads-select>
            <div v-else class="el-input el-input--prefix">
              <input
                v-model="numberSearch"
                type="text"
                autocomplete="off"
                placeholder="Enter number"
                class="el-input__inner"
                v-mask="'(###)-XXX-XXXX'"
              />
              <span class="el-input__prefix">Number</span>
            </div>
          </el-col>
          <el-col :span="1"></el-col>
          <el-col :span="12">
            <dads-select
              v-model="number"
              :value="number"
              v-loading="tfInventoryLoading"
              placeholder="Number"
              filterable
            >
              <template slot="prefix">Number</template>
              <el-option
                v-for="{ label, value } in numberOptions"
                :key="value"
                :label="label"
                :value="value"
              />
            </dads-select>
          </el-col>
        </div>

        <div class="inline-form-group">
          <el-tag v-if="searchType !== 'inventory'">You may enter an X to specify a wildcard for any of the last 7 digits</el-tag>
        </div>

        <dads-select
          v-model="createForm.branchId"
          placeholder="Select a branch"
          allow-create
          filterable
        >
          <template slot="prefix">Branch</template>
          <el-option
            v-for="(item, index) in branchOptions"
            :key="index"
            :label="item.name"
            :value="item.id"
          />
        </dads-select>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import DadsSelect from "@/components/select";
import { debounce } from 'lodash';

import feathersClient from "@/feathers/feathers-client";
import {phoneNumberFormatter} from "@/globals/globals";

export default {
  name: "CreateTollFree",

  props: {
    createProcessing: { required: true },
    createVisible: { required: true },
    branchOptions: { required: true },
    clearFields: { required: true }
  },

  components: {
    DadsSelect
  },

  data() {
    return {
      numberFormatOptions: [
        {
          label: "800-XXX-XXXX",
          value: "800xxxxxxx"
        },
        {
          label: "833-XXX-XXXX",
          value: "833xxxxxxx"
        },
        {
          label: "844-XXX-XXXX",
          value: "844xxxxxxx"
        },
        {
          label: "855-XXX-XXXX",
          value: "855xxxxxxx"
        },
        {
          label: "866-XXX-XXXX",
          value: "866xxxxxxx"
        },
        {
          label: "877-XXX-XXXX",
          value: "877xxxxxxx"
        },
        {
          label: "888-XXX-XXXX",
          value: "888xxxxxxx"
        }
      ],
      exactNumberSearch: '',
      numberOptions: [],
      tfInventoryLoading: false,
      searchType: 'inventory',
      numberSearch: '',
      number: "",
      createForm: {
        numberFormat: "",
        numbers: [],
        branchId: ""
      }
    };
  },

  computed: {
    selectedTenant() {
      return this.$store.state.selectedTenant;
    }
  },

  watch: {
    clearFields: {
      immediate: true,
      handler(val) {
        if (val) {
          this.resetFields();
          this.getDefaultBranch();
        }
      }
    },
    createVisible: {
      handler(val) {
        if (val) {
          this.getDefaultBranch();
        }
      }
    },
    numberSearch: debounce(function () {
      if(this.numberSearch){
        const searchNum = this.numberSearch.replace(/['":/{}()[|\-.<>?_=+ \]]/g, '');
        if(searchNum.length === 10){
          this.getTfInventory(searchNum);
        }
      }
    }, 500),
    searchType(){
      this.number = '';
      this.numberSearch = '';
    }
  },

  methods: {
    resetFields() {
      this.tfInventoryLoading = false;
			this.number="";
      this.numberOptions = [];
      Object.keys(this.createForm).forEach(key => {
        this.createForm[key] = Array.isArray(this.createForm[key]) ? [] : "";
      });
    },

    orderTollFree() {
      const { branchId } = this.createForm;
      const orderBody = {
        tenantId: this.selectedTenant.id,
        numbers: this.number ? [this.number.toString()] : [],
        branchId: branchId ? branchId : null
      };

      this.$emit("orderTollFree", orderBody);
    },

    cancelOperation() {
      this.resetFields();
      this.$emit("cancelOperation");
    },

    numberFormatter(number) {
      number = number.toString();
      return number
        ? phoneNumberFormatter(number)
        : number;
    },

    getTfInventory(numberFormat) {
      const numberOrderingService = feathersClient.service("tn-ordering");
      this.tfInventoryLoading = true;
      this.numberOptions = [];
      this.createForm.numbers = [];
      const params = {
        query: {
          context: "tfInventory",
          numberFormat
        }
      };

      numberOrderingService
        .find(params)
        .then(res => {
          // ⭐️ Notify users if there are no numbers. ⭐️ //
          if (!res.length) {
            this.$notify({
              title: "No Available Numbers",
              message:
                "There Are No Available Numbers For the Selected number format!",
              type: "error"
            });
            this.tfInventoryLoading = false;
            this.numberOptions = [];
          } else {
            this.numberOptions = res.map(({ tn }) => ({
              label: this.numberFormatter(tn),
              value: tn
            }));
            this.createForm.numbers = [];
            this.tfInventoryLoading = false;
          }
        })
        .catch(err => {
          console.log(err);
          if (err.message.includes('Invalid')) {
            this.$notify({
              title: "Invalid Prefix",
              message:
                "The prefix entered is invalid!",
              type: "error"
            });
            this.tfInventoryLoading = false;
          }
        });
    },

    async getDefaultBranch() {
      try {
        const [defaultBranch] = await feathersClient.service("branches").find({
          query: {
            tenantId: this.selectedTenant.id,
            default: 1
          }
        });
        this.createForm.branchId = defaultBranch.id;
      } catch (error) {
        console.log(error)
      }
    },
  },
  async created() {
    await this.getDefaultBranch();
  },
};
</script>
